// extracted by mini-css-extract-plugin
module.exports = {"red":"#e31818","backgroundGrey":"#EAEAEA","lightGrey":"#D5D5D5","grey":"#868686","darkGrey":"#585856","bordeaux":"#821423","blue":"#34A2CD","mint":"#57B695","small":"500","radioFilter":"src-rbb-data-shared-components-TabBar--radioFilter","active":"src-rbb-data-shared-components-TabBar--active","fakeInput":"src-rbb-data-shared-components-TabBar--fakeInput"};
    if(module.hot) {
      // 1590940330817
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  